import React from 'react';
import classNames from 'classnames';

function Form({ theme, multi, classes, noValidate, onSubmit, children, className }) {
  const formThemes = theme ? theme.map((t) => 'form--' + t) : [];
  const formClasses = classNames(
    {
      'form--multi-step': multi
    },
    formThemes ? formThemes : [],
    classes ? classes : [],
    className
  );

  return (
    <form className={formClasses} onSubmit={onSubmit} noValidate={noValidate}>
      {children}
    </form>
  );
}

export default Form;
